import { render, staticRenderFns } from "./PageIntroBlock.vue?vue&type=template&id=4e9077da"
import script from "./PageIntroBlock.vue?vue&type=script&lang=js"
export * from "./PageIntroBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports